import { useEffect } from "react";
import { useLocation } from "react-router";

export function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Stop Lenis so it doesn't fight the scroll reset, then scroll natively
    if (window.__lenis) {
      window.__lenis.stop();
    }

    window.scrollTo({ top: 0, left: 0, behavior: "instant" });

    if (window.__lenis) {
      // Let the DOM settle before restarting Lenis
      requestAnimationFrame(() => {
        window.__lenis?.start();
      });
    }
  }, [pathname]);

  return null;
}
